var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalRights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5957 20.7256C11.5957 15.2872 11.5957 12.5709 13.2855 10.8812C14.9752 9.19141 17.6915 9.19141 23.1299 9.19141H46.1984C51.6368 9.19141 54.3531 9.19141 56.0428 10.8812C57.7326 12.5709 57.7326 15.2872 57.7326 20.7256V43.7941C57.7326 51.9488 57.7326 56.029 55.1979 58.5608C52.6662 61.0954 48.5859 61.0954 40.4313 61.0954H28.897C20.7423 61.0954 16.6621 61.0954 14.1303 58.5608C11.5957 56.029 11.5957 51.9488 11.5957 43.7941V20.7256Z",
    stroke: "#4A709A",
    strokeWidth: 3.244
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0146 23.6133H43.316M26.0146 35.1475H43.316",
    stroke: "#4A709A",
    strokeWidth: 3.244,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalRights);
export default __webpack_public_path__ + "static/media/LegalRights.36ecddbe5af8de467ce77dfd185e3577.svg";
export { ForwardRef as ReactComponent };